import getDate from './get-date';

export { getDate };

export default getDate;
